import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PREFIX_MAP, ROUTE_MAP } from "@/i18n";

/** Keeps <html lang> plus hreflang alternates in sync with the current route. */
export const Hreflang = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isEn = pathname === "/en" || pathname.startsWith("/en/");
    document.documentElement.lang = isEn ? "en" : "ms";

    document.head.querySelectorAll('link[rel="alternate"][data-i18n]').forEach((el) => el.remove());

    // pSEO landing pages publish their own alternates (slugs differ per language).
    if (pathname.startsWith("/direktori/") || /^\/en\/directory\/.+/.test(pathname)) return;

    let pair = ROUTE_MAP.find(([ms, en]) => ms === pathname || en === pathname);
    if (!pair) {
      const prefix = PREFIX_MAP.find(([ms, en]) => pathname.startsWith(ms) || pathname.startsWith(en));
      if (prefix) {
        const from = pathname.startsWith(prefix[1]) ? prefix[1] : prefix[0];
        const rest = pathname.slice(from.length);
        pair = [`${prefix[0]}${rest}`, `${prefix[1]}${rest}`];
      }
    }
    if (!pair) return;

    const origin = window.location.origin;
    [
      ["ms-MY", pair[0]],
      ["en", pair[1]],
      ["x-default", pair[0]],
    ].forEach(([hreflang, path]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hreflang;
      link.href = `${origin}${path}`;
      link.dataset.i18n = "1";
      document.head.appendChild(link);
    });
  }, [pathname]);

  return null;
};
